"use client"
import Basiclayout from '@/components/atomic/Basiclayout'
import { IMAGES, ICONS } from '@/constants/constants'
import Image from 'next/image'
import React, { useRef, useEffect } from 'react'
import SearchTrip from './SearchTrip'
import MobileSearchTrip from './MobileSearchTrip'

const HeroSection = () => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            // Force video to play and handle IDM interference
            const playVideo = async () => {
                try {
                    video.muted = true; // Ensure muted for autoplay
                    await video.play();
                } catch (error) {
                }
            };

            // Play video when component mounts
            playVideo();

            // Handle visibility change (when user switches tabs)
            const handleVisibilityChange = () => {
                if (!document.hidden && video.paused) {
                    playVideo();
                }
            };

            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }
    }, []);

    return (
        <>
            {/* Mobile Version - Below lg breakpoint */}
            <div className="lg:hidden relative min-h-screen font-work-sans">
                <div className="absolute inset-0">
                    <video
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="metadata"
                        controls={false}
                        disablePictureInPicture
                        disableRemotePlayback
                        onContextMenu={(e) => e.preventDefault()}
                        style={{ pointerEvents: 'none' }}
                    >
                        <source src={ICONS.vid} type="video/mp4" />
                        <Image
                            src={IMAGES.home}
                            alt="Background"
                            fill
                            className="object-cover"
                            priority
                        />
                    </video>
                    {/* Dark overlay for text readability */}
                    <div className="absolute inset-0 bg-black/40"></div>

                </div>

                <div className="relative z-10 flex flex-col justify-between min-h-screen">
                    {/* Header Text */}
                    <div className="flex-1 flex flex-col justify-center items-start text-left px-4 pt-8">
                        <h1 className="text-2xl sm:text-3xl font-rakesly font-bold text-white mb-4 tracking-wide leading-tight">
                            COME VISIT OUR COMMUNITY
                        </h1>
                        <p className="text-base sm:text-lg text-white/90 mb-8">
                            All are welcome to learn about our rich history
                        </p>
                    </div>

                    {/* Search Trip Component - Fixed at bottom */}
                    <div className="flex-shrink-0 pb-4 px-4">
                        <MobileSearchTrip />
                    </div>
                </div>
            </div>

            {/* Desktop Version - lg breakpoint and above */}
            <div className="hidden lg:block">
                <Basiclayout className="relative w-full h-96 md:h-[500px] lg:h-[500px] overflow-hidden font-work-sans">
                    {/* Background Video */}
                    <div className="absolute inset-0">
                        <video
                            ref={videoRef}
                            className="w-full h-full object-cover"
                            autoPlay
                            muted
                            loop
                            playsInline
                            preload="metadata"
                            controls={false}
                            disablePictureInPicture
                            disableRemotePlayback
                            onContextMenu={(e) => e.preventDefault()}
                            style={{ pointerEvents: 'none' }}
                        >
                            <source src={ICONS.vid} type="video/mp4" />
                            {/* Fallback image if video fails to load */}
                            <Image
                                className='w-full h-full object-cover'
                                src={IMAGES.ferry}
                                height={1000}
                                width={1000}
                                alt='ferry'
                                priority
                            />
                        </video>
                        {/* Overlay for better text readability and to prevent IDM interference */}
                        <div
                            className="absolute inset-0 bg-black/30"
                            style={{ pointerEvents: 'none' }}
                        ></div>
                    </div>

                    {/* Text Content Overlay */}
                    <div className="relative flex flex-col items-start h-full text-start px-4 pt-20">
                        <h1 className="text-4xl font-rakesly md:text-4xl lg:text-6xl font-bold text-white mb-4 tracking-wide">
                            COME VISIT OUR COMMUNITY
                        </h1>
                        <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-2x pb-10">
                            All are welcome to learn about our rich history
                        </p>
                        <SearchTrip />
                    </div>
                </Basiclayout>
            </div>
        </>
    )
}

export default HeroSection